import axios from "axios";
import { USAGE_SUMMARY_ENDPOINT } from "AppConstants";
import { setAuthHeader } from "app/services/auth.header.service";

/**
 * Usage from the start of `from` to the end of `to` ("yyyy-mm-dd"), for the admin Usage Analytics
 * screen (HRMS-322). Resolves to null when nobody is signed in.
 *
 * @since NEXT_VERSION
 */
export const loadUsageSummary = async (from, to) => {
  const config = setAuthHeader();
  if (!config) return null;
  const params = new URLSearchParams({ from, to });
  return await axios.get(`${USAGE_SUMMARY_ENDPOINT}?${params.toString()}`, config);
};
